import React from 'react';
import classNames from "classnames";
import styles from './XButton.module.scss';
import { XComponent } from '../../commons';
import { ETheme } from '../../../types';
import { IButtonProps } from './IButtonProps';
import { IButtonState } from './IButtonState';

export class XButton extends XComponent<HTMLDivElement, IButtonProps, IButtonState> {
    protected static defaultProps = {
        ...XComponent.defaultProps,
        closeDialog: undefined,
        theme: ETheme.Blue
    }

    public constructor(props: IButtonProps) {
        super(props);
        this.state = {
            theme: this.props.theme === undefined
                ? ETheme.Red
                : this.props.theme
        };
        this.onClick = this.onClick.bind(this);
    }
    
    public componentDidMount(): void {
        super.componentDidMount();
    }

    public componentWillUnmount(): void {
        super.componentWillUnmount();
    }

    private onClick(): void {
        this.props.onClick?.(this);
        if(!this.props.closeDialog) return;

        const {current} = this.reference;
        if(!current)
            return;
        let element: HTMLElement | null = current.parentElement;
        while(element) {            
            if(element instanceof HTMLDialogElement) {                
                const dialog: HTMLDialogElement = element as HTMLDialogElement;
                if(dialog) {
                    dialog.close();
                    document.body.removeChild(dialog);                
                    return;
                }
            }
            if(element instanceof HTMLBodyElement) {
                return;
            }
            element = element.parentElement;
        }        
    }

    public render(): React.ReactNode {
        return (
            <div ref={this.reference}
                className={classNames(styles.XButton)}
                data-theme={this.state.theme}
                onClick={this.onClick}
                >
                {this.props.children}
            </div>
        );
    }
}
